import * as z from "zod";

export const revokeDeviceAuth = {
  name: "revokeDeviceAuth" as const,
  input: z.object({ deviceId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
